import React from 'react';
import UrgencyChip from '../../../Priority/UrgencyChip';
import ComplexityChip from '../../../Priority/ComplexityChip';
import Priority from '../../../Priority/Priority';
import type {
  ComplexityLevel,
  PriorityLevel,
  UrgencyLevel,
} from '../../../Priority/types';

interface PriorityCellProps {
  id: string;
  priorityLevel: PriorityLevel;
  urgency: UrgencyLevel;
  complexity: ComplexityLevel;
}
const PriorityCell = ({
  id,
  priorityLevel,
  urgency,
  complexity,
}: PriorityCellProps) => {
  return (
    <div className="d-flex gap-2 align-items-center">
      <div className="d-flex align-items-center">
        <Priority id={id} priority={priorityLevel} />
      </div>
      <div className="d-flex gap-sm-1 flex-column">
        <UrgencyChip urgency={urgency} />
        <ComplexityChip complexity={complexity} />
      </div>
    </div>
  );
};

export default PriorityCell;
